// extracted by mini-css-extract-plugin
module.exports = {"clientLeagueTables":"clientLeagueTables_clientLeagueTables__Cde_V"};